
import { computed, defineComponent, onMounted, ref } from "vue";
import ClipboardJS from "clipboard";
import UserInfo from "@/core/services/UserInfo";
import ApiService from "@/core/services/ApiService";
import { useRoute } from "vue-router";
import { translate } from "@/core/services/HelpersFun";
// import { Field } from "vee-validate";
import { ElNotification } from "element-plus/es";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "kt-summary",
  components: {
    // Field,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const checkUrl = computed(() => {
      return route.path === `/management/cooperationInSales/${route.params.id}`
        ? "management"
        : "user";
    });

    const user = ref();
    const pay_data = ref({
      sheba: "",
      card_number: "",
      settlement_period: "",
    });
    const pay_info_modal = ref(false);

    onMounted(() => {
      if (checkUrl.value === "management") {
        ApiService.setHeader();
        ApiService.get(
          `/admin/user/${route.params.id}?with_commission=true`
        ).then(({ data }) => {
          user.value = data.data.user;
          tokenString.value = user.value.unique_id;
          tokenString2.value = user.value.referral_link;
        });
      } else {
        user.value = UserInfo.getUser();
        tokenString.value = user.value.unique_id;
        tokenString2.value = user.value.referral_link;
      }
    });

    const tokenString = ref(user.value?.unique_id);
    const inputRef = ref<null | HTMLElement>(null);
    const copyButtonRef = ref<null | HTMLElement>(null);

    const copyCode = () => {
      const clipboard = new ClipboardJS(copyButtonRef.value as Element);
      const buttonCaption = copyButtonRef.value?.innerHTML;

      clipboard.on("success", function (e) {
        //Add bg color
        inputRef.value?.classList.add("bg-success");
        inputRef.value?.classList.add("text-inverse-success");
        const copyButtonRef = ref<null | HTMLElement>(null);

        if (copyButtonRef.value) {
          copyButtonRef.value.innerHTML = translate("copied");
        }

        setTimeout(function () {
          if (copyButtonRef.value && buttonCaption) {
            copyButtonRef.value.innerHTML = buttonCaption;
          }

          // Remove bg color
          inputRef.value?.classList.remove("bg-success");
          inputRef.value?.classList.remove("text-inverse-success");
        }, 3000); // 3seconds

        e.clearSelection();
      });
    };

    const change_pay_info = () => {
      ApiService.post("user/change-financial-setting", {
        sheba: "IR" + pay_data.value.sheba,
        card_number: pay_data.value.card_number,
        settlement_period: pay_data.value.settlement_period,
      })
        .then(({ data }) => {
          console.log(data);
          ElNotification({
            title: "تایید",
            message: "اطلاعات با موفقیت تغییر کرد.",
            type: "success",
          });
          store.dispatch(Actions.VERIFY_AUTH);
          setTimeout(() => {
            user.value = UserInfo.getUser();
          }, 300);
          pay_info_modal.value = false;
          // location.reload();
        })
        .catch((e) => {
          ElNotification({
            title: "خطا",
            message: e.response.data.validation_message,
            type: "error",
          });
        });
    };

    const tokenString2 = ref(user.value?.referral_link);
    const inputRef2 = ref<null | HTMLElement>(null);
    const copyButtonRef2 = ref<null | HTMLElement>(null);

    const copyLink = () => {
      const clipboard = new ClipboardJS(copyButtonRef2.value as Element);
      const buttonCaption = copyButtonRef2.value?.innerHTML;

      clipboard.on("success", function (e) {
        //Add bg color
        inputRef2.value?.classList.add("bg-success");
        inputRef2.value?.classList.add("text-inverse-success");
        const copyButtonRef2 = ref<null | HTMLElement>(null);

        if (copyButtonRef2.value) {
          copyButtonRef2.value.innerHTML = translate("copied");
        }

        setTimeout(function () {
          if (copyButtonRef2.value && buttonCaption) {
            copyButtonRef2.value.innerHTML = buttonCaption;
          }

          // Remove bg color
          inputRef2.value?.classList.remove("bg-success");
          inputRef2.value?.classList.remove("text-inverse-success");
        }, 3000); // 3seconds

        e.clearSelection();
      });
    };

    onMounted(() => {
      copyCode();
      copyLink();

      pay_data.value = {
        sheba: user.value?.sheba?.replace("IR", ""),
        card_number: user.value?.card_number,
        settlement_period: user.value?.settlement_period,
      };

      // pay_data.value.sheba= user.value?.sheba,
      //   pay_data.value.card_number= user.value?.card_number,
      //   pay_data.value.settlement_period= user.value?.settlement_period,

      // tokenString.value = user.value.unique_id;
    });

    return {
      user,
      inputRef,
      copyButtonRef,
      tokenString,
      inputRef2,
      copyButtonRef2,
      tokenString2,
      translate,
      pay_info_modal,
      pay_data,
      change_pay_info,
    };
  },
});
